export const ICON_IMG = {
    unavailable: 'https://s.qunarzz.com/q_design_font/images/radioUnavailable.png',
    selected: 'https://s.qunarzz.com/q_design_font/images/radioSelected.png',
    unselected: 'https://s.qunarzz.com/q_design_font/images/radioUnselected.png'
};
